import { FaHandsHelping, FaPiggyBank, FaChartLine } from "react-icons/fa";
import "./HowWeDoIt.css";
import { Button } from "react-bootstrap";

const ImpactStories = () => {
  return (
    <section className="impact-stories-box">
      <h2 className="impact-heading">Impact Stories Fund in 3 Steps:</h2>
      <div className="impact-steps">
        {/* Step 1 */}
        <div className="impact-step">
          <FaHandsHelping className="impact-icon" />
          <div className="impact-text">
            <h4>Step 1: Sustainable development priorities.</h4>
            <p style={{ color: "white" }}>
              Impact Stories Fund prioritizes development goals with the
              greatest community impact by focusing on initiatives that address
              pressing local needs. The fund carefully evaluates potential
              projects, considering factors such as reach, sustainability, and
              long-term benefits. By investing in stories that showcase
              transformative change, the fund aims to inspire and catalyze
              further community development
            </p>
          </div>
        </div>

        {/* Step 2 - Switched Icon & Text Position */}
        <div className="impact-step reverse">
          <FaPiggyBank className="impact-icon" />
          <div className="impact-text">
            <h4>Step 2: Finding and filming</h4>
            <p style={{ color: "white" }}>
              Impact Stories Fund identifies promising projects through market
              analysis, stakeholder engagement, and SWOT assessments. It
              collaborates with local organizations, evaluates community needs,
              and reviews proposals. The fund then films selected initiatives,
              capturing transformative stories that inspire further development
              and foster sustainable change in communities.
            </p>
          </div>
        </div>

        {/* Step 3 */}
        <div className="impact-step">
          <FaChartLine className="impact-icon" />
          <div className="impact-text">
            <h4>Step 3: Distribution of films</h4>
            <p style={{ color: "white" }}>
              Impact Stories Fund distributes films to maximize public and donor
              viewership, fostering support for selected projects. By leveraging
              screenings, social media, and strategic partnerships, the fund
              closes the loop by generating further backing for impactful
              initiatives, inspiring continued investment and community
              engagement.
            </p>
          </div>
        </div>
        {/* <a href="/how-it-works">
          <Button
            variant="warning"
            size="lg"
            style={{
              backgroundColor: "#ff6b6b",
              fontWeight: "bold",
              border: "none",
              color: "white",
            }}
          >
            More About How it Works
          </Button>
        </a> */}
      </div>
    </section>
  );
};

export default ImpactStories;
